import React from 'react'
import * as S from './Fieldset.style'

const Fieldset = ({ children }) => <S.Fieldset>{children}</S.Fieldset>

export { Fieldset }
